import React, { useMemo } from "react";
import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";

const formatCurrency = (value, currency = "USD") =>
  new Intl.NumberFormat("en-US", {
    style: "currency",
    currency,
    minimumFractionDigits: 2,
  }).format(value);

export default function BillingHistoryTab() {
  const payments = useMemo(
    () => [
      {
        id: "pay-001",
        paidAt: "2025-02-01",
        amountPerLicense: 79,
        licenseCount: 12,
        serviceName: "Elite Core - Annual Subscription",
        currency: "USD",
      },
      {
        id: "pay-002",
        paidAt: "2025-01-01",
        amountPerLicense: 89,
        licenseCount: 10,
        serviceName: "Elite Core - Monthly Subscription",
        currency: "USD",
      },
    ],
    []
  );

  return (
    <Box sx={{ p: 2, display: "grid", gap: 2 }}>
      <Box>
        <Typography variant="h6" sx={{ fontWeight: 800 }}>
          Billing History
        </Typography>
        <Typography variant="body2" sx={{ opacity: 0.8 }}>
          Track subscription payments made to Elite Core.
        </Typography>
      </Box>

      <Paper elevation={2} sx={{ p: 2 }}>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell sx={{ fontWeight: 700 }}>Payment Date</TableCell>
              <TableCell sx={{ fontWeight: 700 }}>Service</TableCell>
              <TableCell sx={{ fontWeight: 700 }}>Amount / License</TableCell>
              <TableCell sx={{ fontWeight: 700 }}>Licenses</TableCell>
              <TableCell sx={{ fontWeight: 700 }}>Total</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {payments.map((row) => (
              <TableRow key={row.id}>
                <TableCell>{row.paidAt}</TableCell>
                <TableCell>{row.serviceName}</TableCell>
                <TableCell>{formatCurrency(row.amountPerLicense, row.currency)}</TableCell>
                <TableCell>{row.licenseCount}</TableCell>
                <TableCell>
                  {formatCurrency(row.amountPerLicense * row.licenseCount, row.currency)}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
        <Typography variant="caption" sx={{ display: "block", mt: 1, opacity: 0.6 }}>
          Data will sync from the new subscription payment model once connected.
        </Typography>
      </Paper>
    </Box>
  );
}
